import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  wrapper: {
    base: {
      position: 'relative',
      display: 'inline-flex',
      width: '20px',
      height: '20px',
    },

    toggle: {
      width: '40px',
    },

    normal: {
      cursor: 'pointer',
    },

    block: {
      display: 'block',
    },

    hasChildrenLeft: {
      marginRight: theme.settings.spacing.large,
    },

    hasChildrenRight: {
      marginLeft: theme.settings.spacing.large,
    },
  },

  outerWrapper: {
    base: {
      display: 'inline-flex',
    },

    card: {
      position: 'relative',
      backgroundColor: 'white',
      width: '100%',
      height: 'auto',
      minHeight: '40px',
      display: 'flex',
      flex: 0,
      marginBottom: theme.settings.spacing.small,
      textAlign: 'left',
      overflow: 'hidden',
      transition: theme.settings.transitions.regular,
      outline: 'none',
      border: '1px solid rgb(235, 237, 238)',
      borderRadius: theme.settings.borderRadiuses.regular,
      padding: '15px 20px',
      cursor: 'pointer',

      ':hover': {
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
      },
      ...theme.settings.focusWithinStyles,
    },

    cardChecked: {
      border: '1px solid rgb(147, 196, 253)',
      backgroundColor: 'rgb(244, 249, 255)',
    },

    hasChildren: {
      position: 'relative',
      alignItems: 'center',
    },

    flush: {
      marginBottom: 0,
    },
  },

  focusWrapper: {
    base: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
    },
    focused: {
      ...theme.settings.focusWithinStyles,
    },
    card: {
      width: '100%',
    },
    right: {
      flexDirection: 'row-reverse',
    },
  },

  label: {
    base: {
      display: 'flex',
      flexGrow: 1,
      cursor: 'pointer',
      color: theme.colors.text.normal,
    },
    readOnly: {
      color: theme.colors.text.dimmed,
    },
    disabled: {
      color: theme.colors.text.dimmed,
    },
    flush: {
      marginRight: 0,
    },
    left: {
      marginRight: theme.settings.spacing.large,
    },
    right: {
      marginLeft: theme.settings.spacing.large,
    },
  },

  toggle: {
    base: {
      position: 'relative',
      width: '40px',
      height: '20px',
      borderRadius: '10px',
      backgroundColor: '#dae2ea',
      transition: theme.settings.transitions.regular,
      ':hover': {
        backgroundColor: 'rgba(153, 153, 153, 0.4)',
      },
    },

    on: {
      backgroundColor: '#02bb4f',
    },

    disabled: {
      backgroundColor: 'rgba(153, 153, 153, 0.3)',
    },

    disabledOn: {
      backgroundColor: 'rgba(153, 153, 153, 0.8)',
    },

    readOnly: {
      backgroundColor: 'rgba(153, 153, 153, 0.3)',
    },

    readOnlyOn: {
      backgroundColor: 'rgba(153, 153, 153, 0.8)',
    },
  },

  toggleIndicator: {
    base: {
      position: 'absolute',
      width: '14px',
      height: '14px',
      top: '3px',
      left: '3px',
      borderRadius: '10px',
      backgroundColor: 'white',
      transition: '150ms ease-in-out',
    },

    on: {
      // Wrapper width - indicator width - pixels from right hand side
      left: `${40 - 14 - 3}px`,
    },

    off: {
      left: '3px',
    },
  },

  input: {
    base: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      opacity: 0,
      cursor: 'pointer',
    },

    disabled: {
      cursor: 'default',
    },

    readOnly: {
      cursor: 'default',
    },
  },

  checkboxFillPath: {
    normal: {
      fill: '#298bff',
    },

    hovered: {
      fill: '#1d70d2',
    },

    disabled: {
      fill: 'rgba(153, 153, 153, 0.4)',
    },

    readOnly: {
      fill: 'rgba(153, 153, 153, 0.4)',
    },
  },
})
